
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.949 7.624H9.793a.594.594 0 01-.594-.594.594.594 0 01.594-.594h4.156a.594.594 0 01.594.594.594.594 0 01-.594.594z","fill":"#697485","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M5.645 8.218a.592.592 0 01-.42-.174l-.594-.594a.594.594 0 010-.84.594.594 0 01.84 0l.174.174 1.362-1.361a.594.594 0 01.84 0 .594.594 0 010 .84L6.064 8.044a.592.592 0 01-.419.174zM13.949 13.166H9.793a.594.594 0 01-.594-.594.594.594 0 01.594-.594h4.156a.594.594 0 01.594.594.594.594 0 01-.594.594zM5.645 13.759a.592.592 0 01-.42-.174l-.594-.594a.594.594 0 010-.84.594.594 0 01.84 0l.174.174 1.362-1.361a.594.594 0 01.84 0 .594.594 0 010 .84l-1.783 1.781a.592.592 0 01-.419.174z","fill":"#697485","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.875 18.011h-4.75c-2.193 0-3.679-.464-4.675-1.46S.99 14.069.99 11.875v-4.75c0-2.193.464-3.678 1.46-4.675S4.932.99 7.125.99h4.75c2.193 0 3.679.464 4.675 1.46s1.46 2.482 1.46 4.675v4.75c0 2.193-.464 3.679-1.46 4.675s-2.481 1.461-4.675 1.461zM7.125 2.178c-1.857 0-3.076.353-3.835 1.112S2.178 5.268 2.178 7.125v4.75c0 1.858.354 3.076 1.113 3.835s1.978 1.113 3.835 1.113h4.75c1.858 0 3.076-.354 3.835-1.113s1.113-1.978 1.113-3.835v-4.75c0-1.858-.354-3.076-1.113-3.835s-1.978-1.112-3.836-1.112z","fill":"#697485"}})])
          )
        }
      }
    